import React, { useEffect, useState, useRef, createContext } from "react";
import { Col, Row } from "react-bootstrap";
import "./Spot.css";
import LeftTable from "./LeftTable";
import RightTable from "./RightTable";
import BuyAndSell from "./BuyAndSell";
import BottomTable from "./BottomTable";
import TvChartContainer from "./TVChart";
import Depth from "./Depth";

import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import FlipNumbers from "react-flip-numbers";

import { useLocation, useNavigate } from "react-router-dom";
import { checkInternetConnection } from "../../CoreDataService";
import { Box, Paper, Typography, alpha } from "@mui/material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import { useSelector } from "react-redux";

export const DataContext = createContext();

const Spot = () => {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [isConnected, setIsConnected] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const pageName = location.pathname.split("/").pop();
  const [activeButton, setActiveButton] = useState("Price");

  const [chartData, setChartData] = useState(null);
  const [ltp, setLtp] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [updateBalance, setUpdateBalance] = useState(false);
  const [updateOrder, setUpdateOrder] = useState(false);

  const [rocData, setRocData] = useState(0);
  const [volumnData, setVolumnData] = useState(0);
  const [lowPrice, setLowPrice] = useState(0);
  const [highPrice, setHighPrice] = useState(0);

  const [isNegative, setIsNegative] = useState(false);
  const [finalBiddata, setFinalBiddata] = useState([]);
  const [finalAskdata, setFinalAskdata] = useState([]);
  const [lastAskItem, setLastAskItem] = useState(null);
  const [firstBidItem, setFirstBidItem] = useState(null);
  const [sellData, setSellData] = useState("");
  const [buyData, setBuyData] = useState("");
  // Parse pair from URL search string (e.g., /spot?BTC-USDT)
  const pairFromUrl = location.search ? location.search.substring(1) : null;
  const [initialCurrency, initialBase] =
    pairFromUrl && pairFromUrl.includes("-")
      ? pairFromUrl.split("-").map((s) => s.toUpperCase())
      : [
          (localStorage.getItem("buying_crypto_asset") || "BTC")?.toUpperCase(),
          (
            localStorage.getItem("selling_crypto_asset") || "USDT"
          )?.toUpperCase(),
        ];

  const [currencycode, setCurrencycode] = useState(initialCurrency);
  const [basecurrency, setBasecurrency] = useState(initialBase);

  const stompClientRef = useRef(null); // Store the Stomp client instance

  const allProps = {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    setCurrencycode,
    setBasecurrency,
    currencycode,
    basecurrency,
    lowPrice,
    highPrice,
    setSellData,
    setBuyData,
    finalBiddata,
    finalAskdata,
    lastAskItem,
    firstBidItem,
    setLastAskItem,
    setFirstBidItem,
    ltp,
    setRefresh,
    refresh,
    updateBalance,
    sellData,
    buyData,
    setUpdateBalance,
    updateOrder,
    setUpdateOrder,
  };
  const reqNo = Math.floor(Math.random() * 1000) + 1;
  const webSocketEndPoint = "https://stream.paybito.com/SocketStream/ws";
  const topicForBtcUsd = "/topic/stream/BTCUSD";
  const topic = "/user/topic/stream";

  // Update URL when pair changes
  useEffect(() => {
    const pair = `${currencycode}-${basecurrency}`;
    navigate(`/spot?${pair}`, { replace: true });
  }, [currencycode, basecurrency]);

  useEffect(() => {
    const spotPageTitle = `${
      chartData?.ltp
    } | ${currencycode.toUpperCase()}${basecurrency.toUpperCase()} | ${localStorage.getItem(
      "exchange"
    )} Spot`;

    if (pageName && pageName.toLowerCase() === "spot") {
      document.title = spotPageTitle;
      return;
    }
  }, [pageName, chartData]);
  console.log("Chart data in Spot component:");

  const _connect = () => {
    if (localStorage.getItem("access_token")) {
      const socket = new SockJS(webSocketEndPoint);
      stompClientRef.current = Stomp.over(socket);
      stompClientRef.current.debug = null; // Disable debug logging

      stompClientRef.current.connect(
        {},
        (frame) => {
          let topicToSubscribe =
            currencycode?.toUpperCase() === "BTC" &&
            basecurrency?.toUpperCase() === "USD"
              ? topicForBtcUsd
              : topic;

          if (stompClientRef.current && stompClientRef.current.connected) {
            stompClientRef.current.subscribe(topicToSubscribe, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });
            subscribe(); // Ensure this doesn't rely on an unready connection
          } else {
            console.error("STOMP connection not ready yet.");
          }
        },
        errorCallBack
      );
    } else {
      console.log("Access token is not available");
    }
  };

  const _disconnect = () => {
    if (stompClientRef.current && stompClientRef.current.connected) {
      stompClientRef.current.disconnect(() => {
        console.log("Disconnected");
      });
    } else {
      console.warn("Disconnect skipped: STOMP client not connected.");
    }
  };

  const errorCallBack = (error) => {
    if (localStorage.getItem("access_token") !== null) {
      setTimeout(() => {
        _connect();
      }, 5000);
    }
  };

  const _send = (message) => {
    if (!stompClientRef.current || !stompClientRef.current.connected) {
      console.error("WebSocket is not connected yet.");
      return;
    }

    const sendMessage = {
      method: "SUBSCRIBE",
      params: [
        `${currencycode.toLowerCase()}/${basecurrency.toLowerCase()}@ticker`,
        `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@depth`,
        `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@trade`,
      ],
      id: reqNo,
    };

    stompClientRef.current.send(
      currencycode.toUpperCase() === "BTC" &&
        basecurrency.toUpperCase() === "USD"
        ? "/app/sendRequest/BTCUSD"
        : "/app/sendRequest",
      {},
      JSON.stringify(sendMessage)
    );
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    const data = parsedMessage.tR;
    if (data !== null) {
      setChartData(data);
      setLowPrice(parseFloat(data?.lowPrice).toFixed(2));
      setHighPrice(parseFloat(data?.highPrice).toFixed(2));

      setRocData(parseFloat(data?.roc).toFixed(2));
      setVolumnData(parseFloat(data?.volume).toFixed(2));
      setIsNegative(data?.roc < 0);
    }
  };

  useEffect(() => {
    // Call the function and get the cleanup function
    const cleanup = checkInternetConnection(setIsConnected);

    // Cleanup listeners when component unmounts
    return () => cleanup();
  }, []);

  const subscribe = () => {
    if (currencycode && basecurrency) {
      const req = {
        method: "SUBSCRIBE",
        params: [
          `${currencycode.toLowerCase()}/${basecurrency.toLowerCase()}@ticker`,
          `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@depth`,
          `${currencycode.toLowerCase()}${basecurrency.toLowerCase()}@trade`,
        ],
        id: reqNo,
      };
      setTimeout(() => {
        _send(req);
      }, 10000);
      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  useEffect(() => {
    const fetchTickerData = () => {
      const buyingCryptoAsset = currencycode;
      const sellingCryptoAsset = basecurrency;

      axios
        .get(
          `https://stream.paybito.com/SocketStream/api/get24hTicker?counter=${buyingCryptoAsset}&base=${sellingCryptoAsset}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          const result = response.data;
          if (result && result.length) {
            const data = result[0];
            setChartData(data);
            setLtp(data?.ltp);
            setLowPrice(parseFloat(data.lowPrice).toFixed(2));
            setHighPrice(parseFloat(data.highPrice).toFixed(2));
            setRocData(parseFloat(data.roc).toFixed(2));
            setVolumnData(parseFloat(data.volume).toFixed(2));
            setIsNegative(data.roc < 0);
          }
          _disconnect(); // Disconnect before connecting again
          _connect();
        })
        .catch((error) => {
          console.error("Error fetching 24h ticker data manually:", error);
        });
    };

    fetchTickerData();

    return () => {
      // Prevent disconnect if client isn't ready
      _disconnect();
    };
  }, [basecurrency, currencycode]);

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <DataContext.Provider value={allProps}>
      <Box sx={pageWrapper}>
        {/* ── Ticker Strip ── */}
        <Box sx={tickerStrip}>
          {/* Left — Pair badge */}
          <Box sx={tickerPairBadge}>
            <Box sx={tickerPairIconWrap}>
              <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff" }} />
            </Box>
            <Box>
              <Typography sx={tickerPairText}>
                {currencycode.toUpperCase()}
                <span style={{ opacity: 0.45, fontWeight: 400 }}>
                  /{basecurrency.toUpperCase()}
                </span>
              </Typography>
              <Typography sx={tickerPairSub}>Spot</Typography>
            </Box>
          </Box>

          {/* Center — Stats */}
          <Box sx={tickerStatsCenter}>
            <Box sx={tickerDivider} />

            {/* Last Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>LAST PRICE</Typography>
              <Typography
                sx={{
                  ...tickerStatValue,
                  color: isNegative ? "#F5475D" : "#21CB80",
                  fontWeight: 800,
                  fontSize: "1rem",
                }}
              >
                <FlipNumbers
                  height={14}
                  width={9}
                  play
                  duration={2}
                  numbers={Number(chartData?.ltp).toLocaleString(undefined, {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}
                />
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Change */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H CHANGE</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                {isNegative ? (
                  <TrendingDownOutlinedIcon
                    sx={{ fontSize: 13, color: "#F5475D" }}
                  />
                ) : (
                  <TrendingUpOutlinedIcon
                    sx={{ fontSize: 13, color: "#21CB80" }}
                  />
                )}
                <Typography
                  sx={{
                    ...tickerStatValue,
                    color: isNegative ? "#F5475D" : "#21CB80",
                  }}
                >
                  {rocData}%
                </Typography>
              </Box>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>
                24H VOL ({basecurrency.toUpperCase()})
              </Typography>
              <Typography sx={tickerStatValue}>{volumnData}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H High */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H HIGH</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#21CB80" }}>
                {highPrice}
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Low */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H LOW</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#F5475D" }}>
                {lowPrice}
              </Typography>
            </Box>

            <Box sx={tickerDivider} />
          </Box>

          {/* Right — Connection status */}
          <Box sx={tickerConnectionWrap}>
            <Box sx={tickerConnectionPill}>
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  flexShrink: 0,
                  backgroundColor: isConnected ? "#21CB80" : "#F5475D",
                  boxShadow: isConnected
                    ? "0 0 5px #21CB80"
                    : "0 0 5px #F5475D",
                  animation: isConnected
                    ? "tickerPulse 2s ease-in-out infinite"
                    : "none",
                }}
              />
              <Typography
                sx={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  color: isConnected ? "#21CB80" : "#F5475D",
                  letterSpacing: "0.06em",
                }}
              >
                {isConnected ? "LIVE" : "OFFLINE"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Main Trading Layout ── */}
        <Box sx={tradingLayout}>
          <Row className="LetfTable" style={{ margin: 0, flex: 1 }}>
            {/* Left Order Book */}
            <Col
              xs={12}
              sm={12}
              md={2}
              className="mb-1 position-relative p-0 orderbooktable"
            >
              <Box sx={panelCard}>
                <LeftTable />
              </Box>
            </Col>

            {/* Chart + Buy/Sell */}
            <Col xs={12} sm={12} md={8} className="mb-1 px-1 spotchart">
              <Box sx={{ ...panelCard, height: "auto" }}>
                {/* Chart toggle buttons */}
                <Box sx={chartToggleWrap}>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor:
                        activeButton === "Price"
                          ? alpha(btncolor || "#1976d2", 0.15)
                          : "transparent",
                      color:
                        activeButton === "Price"
                          ? btncolor || "#1976d2"
                          : "var(--text-color)",
                      borderColor:
                        activeButton === "Price"
                          ? alpha(btncolor || "#1976d2", 0.4)
                          : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Price" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Price")}
                  >
                    <ShowChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Price
                  </Box>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor:
                        activeButton === "Depth"
                          ? alpha(btncolor || "#1976d2", 0.15)
                          : "transparent",
                      color:
                        activeButton === "Depth"
                          ? btncolor || "#1976d2"
                          : "var(--text-color)",
                      borderColor:
                        activeButton === "Depth"
                          ? alpha(btncolor || "#1976d2", 0.4)
                          : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Depth" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Depth")}
                  >
                    <BarChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Depth
                  </Box>
                </Box>

                {activeButton === "Price" ? <TvChartContainer /> : <Depth />}
              </Box>

              <Box sx={{ ...panelCard, mt: "6px", height: "auto" }}>
                <BuyAndSell />
              </Box>
            </Col>

            {/* Right Order Book */}
            <Col xs={12} sm={12} md={2} className="mb-1 p-0 orderbooktable">
              <Box sx={panelCard}>
                <RightTable />
              </Box>
            </Col>

            {/* Bottom Table */}
            <Col xs={12} md={12} className="mb-4 p-0">
              <Box sx={{ ...panelCard, mt: "6px" }}>
                <BottomTable />
              </Box>
            </Col>
          </Row>
        </Box>
      </Box>
    </DataContext.Provider>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

// Ticker strip
const tickerStrip = {
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  px: { xs: 2, md: "14px" },
  py: "10px",
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

// Center stats group — takes remaining space, centers content
const tickerStatsCenter = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  overflow: "hidden",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};

const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};

const tickerPairSub = {
  fontSize: "0.6rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.4,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};

const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  pr: { md: "16px" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

// Trading layout
const tradingLayout = {
  px: "6px",
  pb: "50px",
};

// Panel / card wrapper
const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
  height: "100%",
};

// Chart toggle bar
const chartToggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  px: "8px",
  py: "6px",
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const chartToggleBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "12px",
  py: "5px",
  borderRadius: "8px",
  border: "1px solid",
  fontSize: "0.75rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

export default Spot;
